/**
 * Toast component
 * @returns <Toast />
 */

import Button from "./Button";
import { Link } from "react-router-dom";

const Toast = ({ type, title, product, totalPrice, error }) => {
    if (type === "add-product") {
        return (
            <div className="toast">
                <div className="toast__content">
                    <h4 className="toast__title">{title}</h4>

                    {product && (
                        <div className="toast__product">
                            <div className="toast__product__text">
                                <img
                                    className="type"
                                    src={`${window._env_.STATIC_HOST}/static/website/images/icon-${product.type}-white.svg`}
                                    alt=""
                                />

                                <p>
                                    {product.title}{" "}
                                    {product.hasInstallation && "+ instalación"}
                                </p>
                            </div>

                            <p className="toast__product__price">
                                {product.currency === "USD" ? "U$S" : "$"}{" "}
                                {totalPrice}
                            </p>
                        </div>
                    )}

                    {error && (
                        <div className="toast__product">
                            <div className="toast__product__text">
                                <p>{error}</p>
                            </div>
                        </div>
                    )}
                </div>

                <Link to="/carrito">
                    <Button
                        tag={"button"}
                        text={"Ir al carrito"}
                        color={"white"}
                        hasIcon={true}
                    />
                </Link>
            </div>
        );
    }

    if (type === "add-maintenance") {
        return (
            <div className="toast">
                <div className="toast__content">
                    <h4 className="toast__title">{title}</h4>

                    {product && (
                        <div className="toast__product">
                            <div className="toast__product__text">
                                <img
                                    className="type"
                                    src={`/static/website/images/icon-${product.type}-white.svg`}
                                    alt=""
                                />

                                <p>
                                    {product.title} -{" "}
                                    {product.selectedPlan.label}
                                </p>
                            </div>

                            <p className="toast__product__price">
                                {product.currency === "USD" ? "U$S" : "$"}{" "}
                                {totalPrice}
                            </p>
                        </div>
                    )}

                    {error && (
                        <div className="toast__product">
                            <div className="toast__product__text">
                                <p>{error}</p>
                            </div>
                        </div>
                    )}
                </div>

                <Link to="/carrito">
                    <Button
                        tag={"button"}
                        text={"Ir al carrito"}
                        color={"white"}
                        hasIcon={true}
                    />
                </Link>
            </div>
        );
    }
};

export default Toast;
